module.exports = __webpack_public_path__ + "e50bd0704939fa8ba65ce91a06fb3e4a.ttf";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Angular-Regular.ttf
// module id = 400
// module chunks = 0